import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 17.2321H0V34.0641H66V17.2321Z" fill="#FFDA44" />
    <path d="M66 34.063H0V51H66V34.063Z" fill="#D80027" />
    <path d="M66 0.400024H0V17.232H66V0.400024Z" fill="#D80027" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
